import { render } from "./BudgetsView.vue?vue&type=template&id=15cbc026&scoped=true"
import script from "./BudgetsView.vue?vue&type=script&lang=js"
export * from "./BudgetsView.vue?vue&type=script&lang=js"

import "./BudgetsView.vue?vue&type=style&index=0&id=15cbc026&scoped=true&lang=css"
import "./BudgetsView.vue?vue&type=style&index=1&id=15cbc026&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cbc026"]])

export default __exports__